var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"fma-icon",class:[_vm.iconName],style:([_vm.colorStyle, _vm.fontSizeStyle])})
}
var staticRenderFns = []

export { render, staticRenderFns }